import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/swipe.gif'


const _hoisted_1 = { class: "wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide_item = _resolveComponent("slide-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_answer_button = _resolveComponent("answer-button")!
  const _directive_touch_swipe = _resolveDirective("touch-swipe")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "carousel-header" }, [
      _createElementVNode("img", {
        class: "swipe_img",
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "carousel row no-wrap justify-start items-start",
      style: _normalizeStyle({ ..._ctx.positionStyleObject })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.slides, (slide, index) => {
        return (_openBlock(), _createBlock(_component_slide_item, {
          key: index,
          slide: slide,
          style: _normalizeStyle({ opacity: _ctx.isHiddenSlide(index + 1) ? '0.5' : '1' }),
          onClickButtonWithPayload: _cache[0] || (_cache[0] = (payload) => _ctx.$emit('send-message', payload)),
          class: "q-mr-sm",
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          id: `slide-${index}`
        }, null, 8, ["slide", "style", "id"]))
      }), 128))
    ], 4)), [
      [
        _directive_touch_swipe,
        _ctx.handleSwipe,
        void 0,
        {
          horizontal: true,
          mouse: true
        }
      ]
    ]),
    (!_ctx.isPhoneSize || _ctx.isWidget)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_q_btn, {
            icon: "keyboard_arrow_left",
            color: "black",
            dense: true,
            class: "arrow arrow-left",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.moveRight()), ["stop"]))
          }),
          _createVNode(_component_q_btn, {
            icon: "keyboard_arrow_right",
            color: "black",
            dense: true,
            class: "arrow arrow-right",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.moveLeft()), ["stop"]))
          })
        ], 64))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["answer-buttons-wrap", { 'q-mx-auto': !_ctx.isPhoneSize }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
        return (_openBlock(), _createBlock(_component_answer_button, {
          key: index,
          button: button,
          onClickButtonWithPayload: _cache[4] || (_cache[4] = (payload) => _ctx.$emit('send-message', payload)),
          style: _normalizeStyle({ ..._ctx.CalculaterButtonWidth(button.width) })
        }, null, 8, ["button", "style"]))
      }), 128))
    ], 2), [
      [_vShow, _ctx.isLastMessage]
    ])
  ]))
}